__turbopack_context__.v({
  "icon": "found-lower-price-block-module-scss-module__X_a3uW__icon",
  "root": "found-lower-price-block-module-scss-module__X_a3uW__root",
  "text": "found-lower-price-block-module-scss-module__X_a3uW__text",
  "title": "found-lower-price-block-module-scss-module__X_a3uW__title",
});
